<template>
  <div class="test">
    <div class="wrapper">
      <h2>Тестовое задание от Медиапронет</h2>
    </div>
    <div class="test__base">

      <div class="mpn">
        <div class="mpn__wrapper">
          <h1>Тестовое задание</h1>

          <div class="mpn__content">

            <div class="mpn__column mpn__column_right">

              <div class="mpn__info" v-if="widthScreen < 1024">
                <carousel
                  :per-page="1"
                  :autoplay="false"
                  :loop="true"
                  :paginationPadding="0"
                  :paginationEnabled="true"
                  paginationColor="#ffffff"
                  paginationActiveColor="#14A5DA"
                  :per-page-custom=[[320,1]]
                  :navigationEnabled="false"
                  :adjustableHeight="true"
                  :centerMode="true"
                >
                  <slide>
                    <div class="mpn__info-block cf">
                      <div class="mpn__info-img">
                        <img src="../../assets/tests/mediapronet/pic.png" alt="">
                        <span class="mpn__info-img__icons">
                      <span class="mpn__info-img__icon green"></span>
                      <span class="mpn__info-img__icon blue"></span>
                      <span class="mpn__info-img__icon yellow"></span>
                    </span>
                        <span class="mpn__info-img__text">Текст</span>
                      </div>
                      <div class="mpn__info-text">
                        <div class="mpn__info-text__name">Название</div>
                        <div class="mpn__info-text__title">
                          <span class="mpn__info-text__title-name icon-green">Название</span>
                          <span class="mpn__info-text__title-text">Текст</span>
                        </div>
                        <div class="mpn__info-text__prices cf">
                          <span class="mpn__info-text__prices-flat">1-комн. <span class="mpn__info-text__prices-size">40 м&sup2;</span></span>
                          <span class="mpn__info-text__prices-price">1 560 600 руб.</span>
                        </div>
                        <div class="mpn__info-text__offers">
                          <a href="" title="" class="mpn__info-text__offers-link">120 предложений</a>
                        </div>
                      </div>
                    </div>
                  </slide>
                  <slide>
                    <div class="mpn__info-block cf">
                      <div class="mpn__info-img">
                        <img src="../../assets/tests/mediapronet/pic.png" alt="">
                        <div class="mpn__info-img__icons">
                          <span class="mpn__info-img__icon green"></span>
                          <span class="mpn__info-img__icon blue"></span>
                          <span class="mpn__info-img__icon yellow"></span>
                        </div>
                        <div class="mpn__info-img__text">Текст</div>
                      </div>
                      <div class="mpn__info-text">
                        <div class="mpn__info-text__name">Название</div>
                        <div class="mpn__info-text__title">
                          <span class="mpn__info-text__title-name icon-green">Очень длинное название</span>
                          <span class="mpn__info-text__title-text">Текст</span>
                        </div>
                        <div class="mpn__info-text__prices cf">
                          <span class="mpn__info-text__prices-flat">1-комн. <span class="mpn__info-text__prices-size">40 м&sup2;</span></span>
                          <span class="mpn__info-text__prices-price">1 560 600 руб.</span>
                        </div>
                        <div class="mpn__info-text__offers">
                          <a href="" title="" class="mpn__info-text__offers-link">150 предложений</a>
                        </div>
                      </div>
                    </div>
                  </slide>
                  <slide>
                    <div class="mpn__info-block cf">
                      <div class="mpn__info-img">
                        <img src="../../assets/tests/mediapronet/pic.png" alt="">
                        <div class="mpn__info-img__icons">
                          <span class="mpn__info-img__icon green"></span>
                          <span class="mpn__info-img__icon blue"></span>
                          <span class="mpn__info-img__icon yellow"></span>
                        </div>
                        <div class="mpn__info-img__text">Текст</div>
                      </div>
                      <div class="mpn__info-text">
                        <div class="mpn__info-text__name">Название</div>
                        <div class="mpn__info-text__title">
                          <span class="mpn__info-text__title-name icon-green">Очень длинное произвольное название</span>
                          <span class="mpn__info-text__title-text">Текст</span>
                        </div>
                        <div class="mpn__info-text__prices cf">
                          <span class="mpn__info-text__prices-flat">1-комн. <span class="mpn__info-text__prices-size">40 м&sup2;</span></span>
                          <span class="mpn__info-text__prices-price">1 560 600 руб.</span>
                        </div>
                        <div class="mpn__info-text__prices cf">
                          <span class="mpn__info-text__prices-flat">2-комн. <span class="mpn__info-text__prices-size">60 м&sup2;</span></span>
                          <span class="mpn__info-text__prices-price">2 560 600 руб.</span>
                        </div>
                        <div class="mpn__info-text__prices cf">
                          <span class="mpn__info-text__prices-flat">3-комн. <span class="mpn__info-text__prices-size">92 м&sup2;</span></span>
                          <span class="mpn__info-text__prices-price">4 560 600 руб.</span>
                        </div>
                        <div class="mpn__info-text__offers">
                          <a href="" title="" class="mpn__info-text__offers-link">90 предложений</a>
                        </div>
                      </div>
                    </div>
                  </slide>
                </carousel>
              </div>

              <div class="mpn__info" :class="{'mpn__info_limit': !informMax && widthScreen > 1279}" v-else>
                <div class="mpn__info-block cf">
                  <div class="mpn__info-img">
                    <img src="../../assets/tests/mediapronet/pic.png" alt="">
                    <div class="mpn__info-img__icons">
                      <span class="mpn__info-img__icon green"></span>
                      <span class="mpn__info-img__icon blue"></span>
                      <span class="mpn__info-img__icon yellow"></span>
                    </div>
                    <div class="mpn__info-img__text">Текст</div>
                  </div>
                  <div class="mpn__info-text">
                    <div class="mpn__info-text__name">Название</div>
                    <div class="mpn__info-text__title">
                      <span class="mpn__info-text__title-name icon-green">Название</span>
                      <span class="mpn__info-text__title-text">Текст</span>
                    </div>
                    <div class="mpn__info-text__prices cf">
                      <span class="mpn__info-text__prices-flat">1-комн. <span class="mpn__info-text__prices-size">40 м&sup2;</span></span>
                      <span class="mpn__info-text__prices-price">1 560 600 руб.</span>
                    </div>
                    <div class="mpn__info-text__offers">
                      <a href="" title="" class="mpn__info-text__offers-link">120 предложений</a>
                    </div>
                  </div>
                </div>
                <div class="mpn__info-block cf">
                  <div class="mpn__info-img">
                    <img src="../../assets/tests/mediapronet/pic.png" alt="">
                    <span class="mpn__info-img__icons">
                      <span class="mpn__info-img__icon green"></span>
                      <span class="mpn__info-img__icon blue"></span>
                      <span class="mpn__info-img__icon yellow"></span>
                    </span>
                    <span class="mpn__info-img__text">Текст</span>
                  </div>
                  <div class="mpn__info-text">
                    <div class="mpn__info-text__name">Название</div>
                    <div class="mpn__info-text__title">
                      <span class="mpn__info-text__title-name icon-green">Очень длинное название</span>
                      <span class="mpn__info-text__title-text">Текст</span>
                    </div>
                    <div class="mpn__info-text__prices cf">
                      <span class="mpn__info-text__prices-flat">1-комн. <span class="mpn__info-text__prices-size">40 м&sup2;</span></span>
                      <span class="mpn__info-text__prices-price">1 560 600 руб.</span>
                    </div>
                    <div class="mpn__info-text__offers">
                      <a href="" title="" class="mpn__info-text__offers-link">150 предложений</a>
                    </div>
                  </div>
                </div>
                <div class="mpn__info-block cf">
                  <div class="mpn__info-img">
                    <img src="../../assets/tests/mediapronet/pic.png" alt="">
                    <span class="mpn__info-img__icons">
                      <span class="mpn__info-img__icon green"></span>
                      <span class="mpn__info-img__icon blue"></span>
                      <span class="mpn__info-img__icon yellow"></span>
                    </span>
                    <span class="mpn__info-img__text">Текст</span>
                  </div>
                  <div class="mpn__info-text">
                    <div class="mpn__info-text__name">Название</div>
                    <div class="mpn__info-text__title">
                      <span class="mpn__info-text__title-name icon-green">Очень длинное произвольное название</span>
                      <span class="mpn__info-text__title-text">Текст</span>
                    </div>
                    <div class="mpn__info-text__prices cf">
                      <span class="mpn__info-text__prices-flat">1-комн. <span class="mpn__info-text__prices-size">40 м&sup2;</span></span>
                      <span class="mpn__info-text__prices-price">1 560 600 руб.</span>
                    </div>
                    <div class="mpn__info-text__prices cf">
                      <span class="mpn__info-text__prices-flat">2-комн. <span class="mpn__info-text__prices-size">60 м&sup2;</span></span>
                      <span class="mpn__info-text__prices-price">2 560 600 руб.</span>
                    </div>
                    <div class="mpn__info-text__prices cf">
                      <span class="mpn__info-text__prices-flat">3-комн. <span class="mpn__info-text__prices-size">92 м&sup2;</span></span>
                      <span class="mpn__info-text__prices-price">4 560 600 руб.</span>
                    </div>
                    <div class="mpn__info-text__offers">
                      <a href="" title="" class="mpn__info-text__offers-link">90 предложений</a>
                    </div>
                  </div>
                </div>
              </div>

              <button class="mpn__info-button" v-on:click="lookInfoAll" v-show="!informMax || widthScreen < 1280">Смотреть все</button>

            </div>

            <div class="mpn__column mpn__column_left">

              <div class="mpn__form">
                <div class="mpn__form-name">Заголовок</div>
                <div class="mpn__form-text">Текст генерируется абзацами случайным образом от двух до десяти предложений в абзаце.</div>
                <div class="mpn__form-block">
                  <form>
                    <input type="text" title="Ваше имя" id="form-name" class="mpn__form-input" placeholder="Ваше имя" v-model="formName">
                    <input type="tel" title="Номер телефона" id="form-phone" class="mpn__form-input"
                           placeholder="Номер телефона"
                           v-model="formPhone"
                           v-mask="'+7 (###) ###-##-##'"
                    >
                    <button type="submit" class="mpn__form-submit">Отправить заявку</button>
                    <div class="mpn__form-bottom cf">
                      <div class="mpn__form-check">
                        <input title="" type="checkbox" class="mpn__form-checkbox" id="rules" v-model="rules">
                        <label for="rules" class="mpn__form-label"></label>
                      </div>
                      <div class="mpn__form-rules">Текст генерируется абзацами случайным образом от двух до десяти предложений в абзаце, что позволяет сделать текст более привлекательным.</div>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: "Mediapronet",
  components: { Carousel, Slide },
  data () {
    return {
      formName: '',
      formPhone: '',
      rules: '',
      widthScreen: '',
      informMax: false
    }
  },
  created() {
    window.addEventListener('resize', this.updateWidthScreen);
  },
  methods: {
    updateWidthScreen() {
      this.widthScreen = window.innerWidth;
    },
    lookInfoAll () {
      this.informMax = true
    }
  },
  mounted () {
    this.updateWidthScreen()
    document.getElementsByClassName('VueCarousel-inner')[0].style.height = "auto"
  }
}
</script>

<style lang="scss" scoped>
  .test {
    position: relative;
    margin: 30px 0 0;

    &__base {
      margin: 30px 0 0;
      padding: 30px 0;
      background: #f5f5f5;
    }
  }

  .mpn {
    position: relative;
    font-family: Roboto-Regular, sans-serif;

    h1 {
      @include font(24px, 32px, #000000);
      font-weight: bold;

      @media screen and (min-width: 1024px){
        @include font(32px, 40px, #000000);
      }
    }

    &__wrapper {
      position: relative;
      padding: 0 10px;

      @media screen and (min-width: 1024px){
        width: 992px;
        margin: 0 auto;
      }

      @media screen and (min-width: 1280px){
        width: 1280px;
      }
    }

    &__content {
      position: relative;

      @media screen and (min-width: 1280px){
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
    }

    &__column {
      position: relative;

      &_left {
        padding: 16px;
        background: #f5f8ff;
        margin: 0 -10px;

        @media screen and (min-width: 1024px){
          padding: 32px 40px;
        }

        @media screen and (min-width: 1280px){
          border-radius: 8px 0 0 8px;
          grid-column: 1 / 1;
          grid-row: 1 / 1;
        }
      }

      &_right {
        padding: 0 0 32px;

        @media screen and (min-width: 1280px){
          padding: 32px 40px;
          border-radius: 0 8px 8px 0;
          grid-column: 2 / 2;
          grid-row: 1 / 1;
          background: #ffffff;
        }
      }
    }

    &__form {
      position: relative;

      @media screen and (min-width: 1024px){
        width: 600px;
      }

      @media screen and (min-width: 1280px){
        width: auto;
      }

      &-name {
        font-family: Roboto-Bold, sans-serif;
        @include font(20px, 28px, #000000);
      }

      &-text {
        margin: 4px 0 0;
        @include font(16px, 24px, #626366);
      }

      &-block {
        margin: 32px 0 0;
      }

      &-input {
        display: block;
        width: 100%;
        height: 48px;
        padding: 0 26px 0 24px;
        border: 1px solid #DEDEDE;
        border-radius: 4px;
        background: #f5f8ff;
        @include font(16px, 24px, #626366);

        & + & {
          margin: 12px 0 0;
        }
      }

      &-submit {
        display: block;
        margin: 12px 0 0;
        width: 100%;
        height: 48px;
        padding: 0 24px;
        border: none;
        border-radius: 4px;
        background: #4070FF;
        @include font(16px, 24px, #ffffff);
        cursor: pointer;

        @media screen and (min-width: 1024px){
          display: block;
          width: auto;
        }
      }

      &-bottom {
        position: relative;
        margin: 24px 0 0;

        @media screen and (min-width: 1280px){
          margin: 86px 0 0;
        }
      }

      &-check {
        display: block;
        overflow: hidden;
        width: 20px;
        height: 20px;
        float: left;
        margin-right: 16px;
      }

      &-label {
        display: inline-block;
        position: relative;
        width: 20px;
        height: 20px;
        background: #f5f8ff;
        border: 1px solid #dedede;
        border-radius: 2px;

        input:checked + & {
          border-color: #4070FF;
          background: #4070FF;

          &:before, &:after {
            content: '';
            position: absolute;
            background: #ffffff;
            transform: rotate(-45deg);
          }

          &:before {
            width: 1px;
            height: 6px;
            top: 7px;
            left: 6px;
          }

          &:after {
            width: 8px;
            height: 1px;
            top: 9px;
            left: 7px;
          }
        }
      }

      &-checkbox {
        position: absolute;
        z-index: -1;
        opacity: 0;
      }

      &-rules {
        display: block;
        overflow: hidden;
        @include font(12px, 16px, #626366);

        @media screen and (min-width: 1280px){
          width: 501px;
        }
      }
    }

    &__info {
      position: relative;
      margin: 0 auto;

      @media screen and (min-width: 1024px){
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 24px;
        max-width: none;
        width: auto;
        margin: 0;
      }

      @media screen and (min-width: 1280px){
        background: #ffffff;
        display: block;
        transition: height linear .3s;
      }

      &_limit {
        overflow: hidden;
        height: 335px;

        &:after {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 10;
          height: 30px;
          width: 100%;
          background: linear-gradient(rgba(255,255,255,0) 0%, rgba(255,255,255,.5) 50%, rgba(255,255,255,1) 100%);
        }
      }

      &-button {
        display: none;
        height: 48px;
        margin: 24px 0 0;
        padding: 0 24px;
        border: 0;
        background: #4070FF;
        @include font(16px, 24px, #ffffff);
        cursor: pointer;

        @media screen and (min-width: 1024px){
          display: block;
        }

        @media screen and (min-width: 1280px){
          margin: 10px 0 0;
          border-radius: 4px;
        }
      }

      &-block {
        position: relative;
        border-radius: 8px;
        background: #ffffff;

        @media screen and (min-width: 1280px){
          display: grid;
          grid-template-columns: 189px 1fr;

          & + & {
            margin: 16px 0 0;
          }
        }
      }

      &-img {
        position: relative;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        border-radius: 8px 8px 0 0;

        @media screen and (min-width: 1280px){
          grid-column: 1 / 1;
          grid-row: 1 / 1;
          width: 189px;
          height: 132px;
          border-radius: 4px;
        }

        img {
          position: relative;
          z-index: 1;
          width: auto;
          height: auto;
          min-width: 100%;
          min-height: 100%;
          vertical-align: bottom;
          border-radius: 8px 8px 0 0;
          flex-shrink: 0;

          @media screen and (min-width: 1280px){
            border-radius: 4px;
          }
        }

        &__icons {
          display: inline-block;
          position: absolute;
          z-index: 2;
          bottom: 16px;
          left: 16px;

          @media screen and (min-width: 1280px){
            bottom: 8px;
            left: 8px;
          }
        }

        &__icon {
          display: inline-block;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          vertical-align: bottom;

          & + & {
            margin-left: -8px;
          }

          &.green {
            background: #1DC560;
          }

          &.blue {
            background: #4070FF;
          }

          &.yellow {
            background: #EADB53;
          }
        }

        &__text {
          display: inline-block;
          position: absolute;
          z-index: 2;
          bottom: 16px;
          right: 16px;
          height: 24px;
          padding: 0 8px;
          border-radius: 12px;
          background: #ffffff;
          @include font(12px, 24px, #000000);

          @media screen and (min-width: 1280px){
            bottom: 8px;
            right: 8px;
          }
        }
      }

      &-text {
        position: relative;
        padding: 16px 16px 12px;
        min-height: 132px;

        @media screen and (min-width: 1280px){
          grid-column: 2 / 2;
          grid-row: 1 / 1;
          padding: 16px 16px 32px;
        }

        &__name {
          font-family: Roboto-Bold, sans-serif;
          @include font(16px, 24px, #000000);
        }

        &__title {
          margin: 4px 0 0;
          font-size: 0;

          &-name {
            display: inline-block;
            overflow: hidden;
            max-width: calc(100% - 78px);
            vertical-align: top;
            white-space: nowrap;
            text-overflow: ellipsis;
            @include font(14px, 20px, #000000);

            &.icon-green:before {
              content: '';
              display: inline-block;
              float: left;
              width: 8px;
              height: 8px;
              margin: 5px 8px 0 0;
              border-radius: 50%;
              background: #1DC560;
            }
          }

          &-text {
            display: inline-block;
            width: 78px;
            padding: 0 0 0 8px;
            vertical-align: top;
            @include font(14px, 20px, #000000);

            &:before {
              content: '';
              float: left;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: #DEDEDE;
              margin: -1px 8px 0 0;

              @media screen and (min-width: 1280px){
                border-radius: 2px;
              }
            }
          }
        }

        &__prices {
          height: 16px;
          margin: 4px 0 0;
          @include font(14px, 20px, #000000);
          border-bottom: 1px dotted #000000;

          &-flat {
            display: inline-block;
            float: left;
            height: 20px;
            background: #ffffff;
          }

          &-size {
            color: #626366;
          }

          &-price {
            display: inline-block;
            float: right;
            height: 20px;
            padding-left: 5px;
            background: #ffffff;
          }
        }

        &__offers {
          position: relative;
          clear: both;
          margin: 8px 0 0;

          @media screen and (min-width: 1280px){
            position: absolute;
            left: 16px;
            bottom: 0;
            margin: 0;
          }

          &-link {
            display: inline-block;
            text-decoration: none;
            vertical-align: bottom;
            @include font(16px, 24px, #4070FF);

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  .VueCarousel {
    position: relative;
    margin: 0;
    padding: 0;
    width: 100%;
    height: auto;
    box-sizing: border-box;

    &-pagination {
      position: relative;
      z-index: 0;
      width: 100%;
      margin: 5px auto 0;
    }

    &-dot {
      width: 10px;
      height: 10px;
      background: #dedede !important;
      border-radius: 50%;
      margin-left: 5px;
      margin-right: 5px;

      &--active {
        background: #4070FF !important;
      }
    }

    &-navigation {
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 1;
      transform: translateX(-50%);
      margin: -11px auto 0;
      width: 100%;
      max-width: 1140px;

      &-button {
        position: absolute;
        top: 0;
        width: 41px;
        height: 22px;
        font-size: 0;
        padding: 0 !important;
        margin: 0 !important;

        &:focus, &:hover {
          outline: none;
        }

        &:after {
          content: '\2192';
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          outline: none;
          font-size: 40px;
          color: #4070FF;

          &:hover, &:active {
            outline: none;
          }
        }

        &:hover {
          opacity: 1;
          outline:none;
        }
      }

      &-prev {
        left: 41px;
        outline: none;
        transform: translateY(-50%) translateX(-12px) !important;

        &:after {
          transform: scale(-1, 1);
        }
      }

      &-next {
        right: 31px;
        outline: none;
        transform: translateY(-50%) translateX(12px) !important;
      }
    }
  }

  @-moz-document url-prefix() {
    .VueCarousel-slide-adjustableHeight {
      display: block !important;
    }
  }

  .VueCarousel-slide-adjustableHeight {
    flex-basis: inherit !important;
  }
</style>
